import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleInput from "../../../../modules/SimpleInput";
import NormalInput from "../../../../modules/NormalInput";

import FormJasa from "./formJasa";
import DDLCompany from "../../../../modules/commons/DDLCompany";

import Button from "../../../../modules/commons/Button";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import SimpleInputRowSmall from "../../../../modules/SimpleInputRowSmall";
const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class Voucher extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable: [
        [
          "1",
          "Voucher hihihi",
          "296UGSK2",
          "RSJ",
          "8",
          "Demak",
          "Batam",
          "Express",
          "Active",
        ],
        [
          "2",
          "Voucher hahaha",
          "2789GHS2",
          "LPR",
          "3",
          "Bali",
          "Jakarta",
          "Regular",
          "Active",
        ],
        [
          "3",
          "Voucher hehehe",
          "3891JKL3",
          "VAC",
          "2",
          "Paris",
          "London",
          "Premium",
          "Active",
        ],
        [
          "4",
          "Voucher haha",
          "4902MNO4",
          "EXP",
          "4",
          "Tokyo",
          "Seoul",
          "Business",
          "Active",
        ],
        [
          "5",
          "Voucher lol",
          "5948PQR5",
          "LPR",
          "1",
          "Rome",
          "Madrid",
          "Regular",
          "Active",
        ],
        [
          "6",
          "Voucher rofl",
          "6997STU6",
          "VAC",
          "3",
          "Sydney",
          "Melbourne",
          "Premium",
          "Active",
        ],
        ["7", "Call Context 7", "", "", "", "", "", "", ""],
      ],

      dataTable2: [
        [
          "1",
          "9136DGY9",
          "296UGSK2",
          "HYK",
          "Active",
          "Now",
          "28-09-2023",
        ],
        [
          "2",
          "2468XYZ1",
          "789ABC23",
          "LMN",
          "Inactive",
          "Later",
          "15-12-2024"
        ],
        [
          "3",
          "1357UVW2",
          "456DEF78",
          "OPQ",
          "Active",
          "Today",
          "03-05-2025"
        ],
        [
          "4",
          "3690RST4",
          "901GHI56",
          "JKL",
          "Inactive",
          "Tomorrow",
          "20-11-2026"
        ],
        [
          "5",
          "5792ABC3",
          "567JKL89",
          "MNO",
          "Active",
          "Yesterday",
          "10-08-2027"
        ],
        [
          "6",
          "8023PQR5",
          "234MNO67",
          "STU",
          "Inactive",
          "Soon",
          "07-06-2028"
        ]
      ],
      selectedIndex: [],
      dmlchoices: [""],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
      cari: null,
      parts: null,
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    console.log("getCountPage");
    let payload = {
      // limit: limit,
      // offset: page,
      // filter: this.state.table_query,
      // companyId: this.state.dataDto.companyId,
      // companyGroupId: null,
      // category: null,
      // isActive: null,
      // sortBy: this.state.dataDto.sortBy ?? "",
      // orderBy: this.state.dataDto.orderBy ?? "",
    };
    console.log(payload);

    // let res = await API.create('LOCAL_BANK').getBank(payload)
    // if (res.ok) {
    //     console.log('here')
    //     if (res.data.data === null) {
    //         this.setState({ dataTable: [] })
    //     } else {
    //         // console.log(JSON.stringify(res.data.data, null, 2));
    //         let dataTable = res.data.data && res.data.data.map((value) => {
    //             const { bankcode, bankname, accountnumber, address, kecamatan, kota, provinsi, kodepos, phonenumber, namadealer, integration, status } = value;
    //             return [
    //                 bankcode,
    //                 bankname,
    //                 accountnumber,
    //                 address,
    //                 kecamatan,
    //                 kota,
    //                 provinsi,
    //                 kodepos,
    //                 phonenumber,
    //                 namadealer,
    //                 integration,
    //                 status?"ACTIVE":"NONACTIVE",
    //             ];
    //         });
    //         console.log('datatable', dataTable)
    //         this.setState({
    //             rawData: res.data.data && res.data.data.listUser,
    //             dataTable,
    //             toCount: res.data.data && res.data.data.dataOfRecord
    //         })
    //         this.onFinishFetch();
    //     }
    // } else{
    //     console.log('error')
    // }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsUser = [
    { name: "No" },
    { name: "Nama Voucher" },
    { name: "Voucher ID" },
    { name: "Module" },
    { name: "Jumlah Voucher" },
    { name: "From" },
    { name: "To" },
    { name: "Type" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage(
                  "slide-menu-1",
                  tableMeta.rowIndex,
                  "companyGroup"
                )}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={this.opSidePage('slide-menu-view', tableMeta.rowIndex)}
                                permission=""
                            >
                                <i className="fa fa-lw fa-ellipsis-v"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  columnsUser2 = [
    { name: "No" },
    { name: "Voucher No." },
    { name: "Voucher ID" },
    { name: "Value" },
    { name: "Status" },
    { name: "Used" },
    { name: "Dated Used" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage(
                  "slide-menu-1",
                  tableMeta.rowIndex,
                  "companyGroup"
                )}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={this.opSidePage('slide-menu-view', tableMeta.rowIndex)}
                                permission=""
                            >
                                <i className="fa fa-lw fa-ellipsis-v"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      serverSide: true,
      count: toCount,
      filter: false,
      search: false,
      viewColumns: false,
      searchText: table_query,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Master Voucher</Tab>
            </TabList>
            <TabPanel>
              <div>
                <div
                  style={{
                    display: "flex",
                    marginBottom: "15px",
                    marginTop: "15px",
                  }}
                >
                  <div>
                    <Button
                      type="button"
                      style={{ width: "130px", height: "40px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-plus"
                          style={{ marginRight: "10px" }}
                        />
                        Tambah
                      </span>
                    </Button>
                    <Button
                      type="button"
                      style={{ width: "130px", height: "40px" }}
                      className="background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      // onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i style={{ marginRight: "10px" }} />
                        Unggah
                      </span>
                    </Button>
                  </div>
                  <div
                    style={{ width: 50, display: "flex", marginLeft: "750px" }}
                  >
                    <div style={{}}>
                      <SimpleInputRowSmall
                        label={"Cari"}
                        name="cari"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.cari}
                        onChange={this.onchangeInput}
                      />
                    </div>
                    <div>
                      <Button
                        type="button"
                        style={{ width: 60, height: "40px" }}
                        className="background-red margin-left-5px"
                        valueCombo={this.state.data.companyIdSelect}
                        // onClick={this.openCreateForm.bind(this)}
                      >
                        <span>
                          <i />
                          Cari
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    title= {"Voucher List"}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
              </div>
              <div
                style={{
                  width: 50,
                  display: "flex",
                  marginLeft: "1030px",
                  marginTop: "30px",
                }}
              >
                <div style={{}}>
                  <SimpleInputRowSmall
                    label={"Cari"}
                    name="cari"
                    // readOnly={this.props.type !== "create"}
                    value={this.state.data.cari}
                    onChange={this.onchangeInput}
                  />
                </div>
                <div>
                  <Button
                    type="button"
                    style={{ width: 60, height: "40px" }}
                    className="background-red margin-left-5px"
                    valueCombo={this.state.data.companyIdSelect}
                    // onClick={this.openCreateForm.bind(this)}
                  >
                    <span>
                      <i />
                      Cari
                    </span>
                  </Button>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    data={this.state.dataTable2}
                    columns={this.columnsUser2}
                    title={"Voucher No"}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
              </div>
            </TabPanel>
          </Tabs>
        </div>

        <div>
          {this.state.createVisible && (
            <FormJasa
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormJasa
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    masterdata: state.masterdata,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Voucher);
